import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      return "/home";
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    // component: resolve=>(require(["../views/Home.vue"],resolve))
  },
  {
    path: "/singlemessage",
    name: "singlemessage",
    component: () => import("../views/singlemessage.vue"),
  },
  {
    path: "/homeEn",
    name: "homeEn",
    component: () => import("../views/homeEn.vue"),
  },
  {
    path: "/contentView",
    name: "contentView",
    component: () => import("../views/content/content.vue"),

  },
  {
    path: "/enteringurban/:name",
    name: "enteringurban",
    component: () => import("../views/enteringurban/index.vue"),
    props: true,
  },
  {
    path: "/contentView/map",
    name: "contentView/map",
    component: () => import("../views/map/index.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/index.vue"),
  }, {
    path: "/message",
    name: "message",
    component: () => import("../views/message/index.vue"),
  }, {
    path: "/operate",
    name: "operate",
    component: () => import("../views/operate/index.vue"),
  }, {
    path: "/political",
    name: "political",
    component: () => import("../views/political/index.vue"),
  }, {
    path: "/corporate",
    name: "corporate",
    component: () => import("../views/corporate/index.vue"),
  }, {
    path: "/callus",
    name: "callus",
    component: () => import("../views/callus/index.vue"),
  }, {
    path: "/richtext/detail",
    name: "richtextDetail",
    component: () => import("../views/richtext/detail/index.vue"),
    // props: true
  },
];
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  let a = false; // 维护时候改为true
  if (a) {
    if (to.path === "/uphold") {
      next();
    } else {
      next({ path: "/uphold" });
    }
  } else {
    next();
  }

});
export default router;
